import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";
import { GeneralMethods } from "../../Handlers/GeneralMethods";
import { SubscriptionData, TraineeSubscription } from "../../Models/Trainee";
import { Router } from "../../Handlers/Router";
import HRPage from "../../../Component/Admin/HRPage";
import Profile from "../../../Component/Client/Profile";
import { AxiosRequest } from "../../Handlers/AxiosHandler";

export class EditClientSubscribeVM extends InterActive{
    private levelSpecializations:{id:string , price:string , name:string }[] = []
    private accounts:{id:string , name:string , banck_account_id:string , currency:{id:string , account:string , arabic_currency_name:string , english_currency_name:string , price:number } }[] = []
    private data:{ id:string , name:string , levelSpecializations_id:string ,account_id:string , discount:string , price:string , verification:string }={ id:'' , name:'' , levelSpecializations_id:'' ,account_id:'' , price:'', discount:'' , verification:'verify' }
    private currencyPrice:number = 0
    private localPrice:number= 0

    private originalDiscount:string = ''
    private id:string = ''

    public get Data():{ id:string , name:string , levelSpecializations_id:string ,account_id:string , discount:string , price:string , verification:string }{ return this.data }

    public get LevelSpecializations():{label:string , value:string }[] { return this.levelSpecializations.map(a=>({label:a.name , value:a.id}))}
    public get Accounts():{label:string , value:string }[] { return this.accounts.map(a=>({label:a.name , value:a.id})) }
    public get Price():string { return  this.data.price }
    public get LocalPrice():number{ return this.localPrice }
    public get CurrencyPrice():number { return this.currencyPrice }

    private clearImg:()=>void = ()=>{};
    public get ClearImg():()=>void{ return this.clearImg  }
    public set ClearImg(value:()=>void){ this.clearImg = value ; this.update()  }

    public set Specialization(value:string){ 
        this.data.levelSpecializations_id = value; 
        this.data.price = this.levelSpecializations.find(a=>a.id===value)?.price||'';  
        this.localPrice = Math.round(Number(this.data.price)*Number(this.currencyPrice)*100)/100
        this.update() }
    public set Account(value:string ){ this.data.account_id = value; this.CurrencyPrice = this.accounts.find(a=>a.id===value)?.currency.price||0; this.data.discount = ((Number(this.currencyPrice))*Number(this.originalDiscount)).toString()  ;this.update() }
    //public set Discount(value:string){ this.data.discount = value?GeneralMethods.removeNonFloatNumeric(value):'0';  this.calculateRemainning(); this.update() }
    public set Discount(value:string){ this.data.discount =  Number(GeneralMethods.removeNonPositiveFloatNumeric(value))<0 ?'0':(Number(GeneralMethods.removeNonPositiveFloatNumeric(value)) > (this.localPrice)?(this.localPrice):GeneralMethods.removeNonPositiveFloatNumeric(value)).toString(); this.update()  }
    public set Verification(value:string){ this.data.verification = value; this.update() }
    private set CurrencyPrice(value:number){ this.currencyPrice = value; this.localPrice = Math.ceil( Number(this.Price)*value *100)/100 }

    constructor(data:TraineeSubscription ,name:string){
        super()
        //{ id:'' , name:'' , levelSpecializations_id:'' ,account_id:'' , price:'', discount:'0' , paid:'0' , remainning:'' , verification:'verify', transffer_date:'' ,img:null , img_name:'' , additional:'' , notes:'' }
        this.data.name = name
        this.data.id = data.subscription.id
        this.data.levelSpecializations_id = data.subscription.level_specialization_id
        this.data.verification = data.subscription.verification
        this.data.discount= data.subscription.discount
        this.originalDiscount = data.subscription.discount
        this.data.price= data.subscription.price
        //this.getLists()
    }


    public getLists(id:string,specialization:string){
        this.id = id
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getAccountsAndLevelSpecializations(id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.levelSpecializations = [{id:this.data.levelSpecializations_id , price:this.data.price , name:specialization},...response.data.data.levelSpecializations]
                                this.accounts = response.data.data.accounts
                                this.update()
                            }else  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                        }else  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{  Notify({type:'danger' , title:'فشل العملية' , body:'فشل العملية ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'}) }
            }
        )
    }

    public send(){
        if(this.validate()){
            this.loading(
                async()=>{
                    try{
                        const response = await AxiosRequest.statusPost<FormData>('editClientSubscriptions',this.toFormData())
                        if(response){
                            if(response.status === HttpStatusCode.Ok){
                                if(response.data.status){
                                    Router.OpenNormalPage(<Profile id={this.id}/>)
                                    Notify({type:'success' , title:'عملية ناجحة' , body:'تم التسجيل بنجاح'})
                                }else Notify({type:'danger' , title:'فشل العملية' , body:response.data.messege})
                            }else Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخري'})
                        }
                        this.update()
                    }catch{
                        Notify({type:'danger' , title:'فشل العملية' , body:'خطأ غير معروف ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخري'})
                    }
                }
            )
        }
    }

    private validate(){
        if(!this.data.levelSpecializations_id){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء اختيار التخصص'}); return false; }
        if(!this.data.account_id){ Notify({type:'danger' , title:'البيانات غير صالحة' , body:'برجاء اختيار الحساب'}); return false; }
        return true;
    }

    private toFormData():FormData{
        console.log(this.data)
        const formData = new FormData()
        formData.append('id' , this.data.id)
        formData.append('name' , this.data.name)
        formData.append('levelSpecializations_id' , this.data.levelSpecializations_id)
        formData.append('level_specialization' , this.levelSpecializations.find(a=>a.id===this.data.levelSpecializations_id)?.name||'')
        formData.append('account_id' , this.data.account_id)
        formData.append('price' , this.data.price)
        formData.append('discount' , this.data.discount)
        formData.append('verification' , this.data.verification)

        return formData
    }
}